var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttach = function SvgAttach(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.286 20h-.572a2.571 2.571 0 0 1-2.571-2.571V7.714A3.726 3.726 0 0 1 10.857 4h2.286a3.726 3.726 0 0 1 3.714 3.714v9.143a.857.857 0 1 1-1.714 0V7.714a2.012 2.012 0 0 0-2-2h-2.286a2.011 2.011 0 0 0-2 2v9.715a.869.869 0 0 0 .857.857h.572a.869.869 0 0 0 .857-.857v-8a.857.857 0 0 1 1.714 0v8A2.57 2.57 0 0 1 10.286 20z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttach);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "attach.e592058343e92ca73dc3b8d7fbe2754c.svg";